webpackJsonp([240036240442609],{

/***/ 1222:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CensusPlacementAction","kind":"ENUM","type":"OBJECT","fields":null,"description":"What is being proposed, which decides what counts as warning about itself.","enumValues":[{"deprecationReason":null,"description":"Put a patient physically into the kennel. Requires `patientId`.","isDeprecated":false,"name":"PLACE_PATIENT"},{"deprecationReason":null,"description":"Book the kennel for an appointment. Requires `appointmentId`.","isDeprecated":false,"name":"RESERVE_APPOINTMENT"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-census-placement-action-98a916bc1fc7b2cf3057.js